import { apiDelete, apiGet, apiPost, apiPut } from '../../generic/Api_Functions'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { systemValueDescription, systemValueLabel, systemValueOptionText } from '../../generic/systemValues/systemValueLabel'

const FabricationOrderStatus = () => {
  const { t_ } = useSmartTranslation()

  const columns = [
    {
      name: t_('Code'),
      field: 'code',
      unique: true,
      mandatory: true,
      readOnly: true,
      charLimit: 60
    },
    {
      name: t_('Name'),
      field: 'name',
      render: (row) => systemValueLabel(t_, 'fabrication_order_status', row),
      renderOnlyInReadMode: true,
      unique: true,
      mandatory: true,
      charLimit: 80,
      readOnly: (row) => {
        return row.systemDefault
      }
    },
    {
      name: t_('Description'),
      field: 'description',
      charLimit: 200,
      // P10: a seeded row's description is factory text and reads translated; a customer row keeps its own.
      render: (row) => systemValueDescription(t_, 'fabrication_order_status', row),
      renderOnlyInReadMode: true
    },
    {
      name: t_('FO status type'),
      field: 'fabricationOrderStatusType.name',
      render: (row) => systemValueLabel(t_, 'fabrication_order_status_type', row.fabricationOrderStatusType),
      renderOnlyInReadMode: true,
      filterByLabel: { options: (items) => items.map((item) => ({ value: item.name, label: systemValueLabel(t_, 'fabrication_order_status_type', item) })) },
      type: 'smartSelect',
      edit: {
        source: async () => {
          return await apiGet('fabricationOrderStatusTypeBasicWithoutWaiting')
        },
        id: 'id',
        field: 'name',
        optionLabel: (name, items) => systemValueOptionText(t_, 'fabrication_order_status_type', items, name)
      },
      readOnly: (row) => {
        return row.systemDefault
      },
      mandatory: true
    }
  ]

  const actions = {
    create: {
      fetchFunction: (row) => {
        return apiPost('fabricationOrderStatus/create', row)
      }
    },
    edit: {
      fetchFunction: (row) => {
        return apiPut('fabricationOrderStatus', row)
      }
    },
    delete: {
      visibilityButton: row => !row.systemDefault,
      fetchFunction: (rows) => {
        if (rows.length === 1) {
          return apiDelete('fabricationOrderStatus/' + rows[0].id)
        } else {
          return apiDelete('fabricationOrderStatus/deleteMulti/', rows)
        }
      }
    }
  }
  const getData = async (pagination) => {
    return await apiGet('fabricationOrderStatus', pagination)
  }

  return (
    <SmartMateriaUITable
      tableTuneUniqueKey='fabricationOrderStatus'
      columns={columns}
      title={t_('Fabrication order status')}
      dataFetch={getData}
      actions={actions}
      pageable
      multipleSelection
      safeDeleteShowProperty='name'
    />
  )
}

export default FabricationOrderStatus
